import React, { useEffect, useState, useMemo, useRef } from "react";

import Table from "../components/table/Table";

import Modal from "../components/modal/Modal";
import { Box } from "@mui/system";
import TripEntry from "./trip/TripEntry";
import { useDispatch, useSelector } from "react-redux";
import { fetchAlltrips } from "../redux/features/trip.features";
import { Link } from "react-router-dom";
import StatusCard from "../components/status-card/StatusCard";
import { Button, ButtonGroup, TextField } from "@mui/material";
import CustomSelectBox from "../components/CustomSelectBox/CustomSelectBox";
import { fetchAllSales } from "../redux/features/sales.features";
import { fetchAllProduct } from "../redux/features/product.features";
import converter from "number-to-words";
import { useReactToPrint } from "react-to-print";

const tripTableHead = [
  "trip Id",
  "trip Name",
  "Start Date",
  "End Date",
  "From",
  "To",
  "Expense",
  "Visited cities",
  "Status",
  "Actions",
];

const renderHead = (item, index) => <th key={index}>{item}</th>;

const initialValues = {
  tripName: "",
  startDate: "",
  endDate: "",
  fromCountry: "",
  toCountry: "",
  expense: "",
  cities: "",
  status: "",
};

const Trips = () => {
  const dispatch = useDispatch();

  const [values, setValues] = useState(initialValues);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setValues({
      ...values,
      [name]: value,
    });
  };

  useEffect(() => {
    dispatch(fetchAllSales());
    dispatch(fetchAllProduct());
  }, [dispatch]);

  const [selectedData, setselectedData] = React.useState(null);
  const [showModal, updateShowModal] = React.useState(false);
  const toggleModal = () => {
    updateShowModal((state) => !state);
    dispatch(fetchAlltrips());
  };

  const [showEditModal, updateShowEditModal] = React.useState(false);
  const toggleEditModal = () => {
    updateShowEditModal((state) => !state);
    dispatch(fetchAlltrips());
  };

  const [showManage, updateshowManage] = React.useState(false);
  const toggleManage = () => {
    updateshowManage((state) => !state);
    dispatch(fetchAlltrips());
  };

  const renderBody = (item, index) => (
    <tr key={index}>
      {/* <td>{item.id}</td> */}
      <td>{item.tripId}</td>
      <td>{item.tripName}</td>
      <td>{item.startDate}</td>
      <td>{item.endDate}</td>
      <td>{item.fromCountry}</td>
      <td>{item.toCountry}</td>

      <td className="text-right">{Number(item.expense).toLocaleString()} </td>
      <td>{item.cities}</td>
      <td>
        {String(item.status).toLowerCase() === "active" ? (
          <p className="p-1 py-2 bg-green-500 rounded">{item.status}</p>
        ) : (
          <p className="p-1 py-2 bg-red-700 rounded">{item.status}</p>
        )}
      </td>
      {showManage && (
        <td className="text-right flex items-center">
          <div
            onClick={() => {
              toggleEditModal();
              setselectedData(item);
            }}
            className="bg-red-500 rounded p-2 bx bx-edit mx-2"
          ></div>
          <div className="bg-green-500 rounded p-2 bx bx-show mx-2"></div>
        </td>
      )}
    </tr>
  );

  let tripState = useSelector((state) => {
    return state.tripReducer;
  });
  let productState = useSelector((state) => {
    return state.productReducer;
  });
  let salesState = useSelector((state) => {
    return state.salesReducer;
  });
  let { sales } = salesState;
  let { products } = productState;
  let { trips, loading } = tripState;

  const [inStock, setInstock] = useState([]);
  const [inStockCurrentMonth, setInstockCurrentMonth] = useState([]);
  const [InStockCurrentMonthPurchase, setInstockCurrentMonthPurchase] =
    useState(0);
  const [inStockPurchaseAmount, setinStockPurchaseAmount] = useState(0);
  const [inStockEstimatedAmountUSD, setinStockEstimatedAmountUSD] = useState(0);
  const [inStockEstimatedAmountLKR, setinStockEstimatedAmountLKR] = useState(0);
  const [outStockCurrentMonth, setoutStockCurrentMonth] = useState([]);
  const [outStockTotalSalesLKR, setoutStockTotalSalesLKR] = useState(0);
  const [outStockTotalSalesUSD, setoutStockTotalSalesUSD] = useState(0);
  const [outStockCurrentMonthSalesLKR, setoutStockCurrentMonthSalesLKR] =
    useState(0);
  const [outStockCurrentMonthSalesUSD, setoutStockCurrentMonthSalesUSD] =
    useState(0);
  const [outStockPurchaseAmount, setoutStockPurchaseAmount] = useState(0);
  const [outStockEstimatedAmount, setoutStockEstimatedAmount] = useState(0);

  const [outStock, setOutstock] = useState([]);
  useEffect(() => {
    setOutstock(products.filter((x) => x.isSold));
    setInstock(
      products.filter((x) => x.isSold === false || x.isSold === undefined)
    );
  }, [products]);

  useEffect(() => {
    let totalPurchase = 0;
    let totalEstimatedSalesLKR = 0;
    let totalEstimatedSalesUSD = 0;
    let CurrentMonthPurchase = 0;
    let currentMonthINvoices = [];
    inStock.forEach((x) => (totalPurchase += Number(x.buyPrice || 0)));
    inStock.forEach(
      (x) => (totalEstimatedSalesUSD += Number(x.sellPriceForeigners || 0))
    );
    inStock.forEach(
      (x) => (totalEstimatedSalesLKR += Number(x.sellPriceLocal || 0))
    );
    currentMonthINvoices = inStock.filter((x) => {
      let month = Number(x.date.split("-")[1]) === new Date().getMonth() + 1;
      let year = Number(x.date.split("-")[2]) === new Date().getFullYear();

      return month && year;
    });

    currentMonthINvoices.forEach((x) => (CurrentMonthPurchase += x.buyPrice));
    setInstockCurrentMonth(currentMonthINvoices);
    console.log("currentMonthINvoices", currentMonthINvoices);
    setinStockPurchaseAmount(totalPurchase);
    setinStockEstimatedAmountLKR(totalEstimatedSalesLKR);
    setinStockEstimatedAmountUSD(totalEstimatedSalesUSD);
    setInstockCurrentMonthPurchase(CurrentMonthPurchase);
  }, [inStock]);

  useEffect(() => {
    let totalPurchase = 0;
    let totalEstimatedSales = 0;
    let CurrentMonthSalesUSD = 0;
    let CurrentMonthSalesLKR = 0;
    let TotalSalesUSD = 0;
    let TotalSalesLKR = 0;
    let currentMonthINvoices = [];

    let allSoldItems = [];
    sales.map((x) => x.invoiceItemList.map((y) => allSoldItems.push(y)));
    console.log("allSoldItems ====> ", allSoldItems);

    allSoldItems.forEach((x) => (totalPurchase += Number(x.buyPrice || 0)));
    allSoldItems.forEach(
      (x) => (totalEstimatedSales += Number(x.sellPriceForeigners || 0))
    );
    currentMonthINvoices = sales.filter((x) => {
      //date format '2022-07-03T00:00:00+05:30'
      let month =
        Number(x.invoiceCreatedDate.split("-")[1]) ===
        new Date().getMonth() + 1;
      let year =
        Number(x.invoiceCreatedDate.split("-")[0]) === new Date().getFullYear();

      return month && year;
    });

    currentMonthINvoices.forEach((x) => {
      if (x.invoiceCurrency === "USD") {
        CurrentMonthSalesUSD += Number(x.invoiceGrandTotal);
      } else {
        CurrentMonthSalesLKR += Number(x.invoiceGrandTotal);
      }
    });

    sales.forEach((x) => {
      if (x.invoiceCurrency === "USD") {
        TotalSalesUSD += Number(x.invoiceGrandTotal);
      } else {
        TotalSalesLKR += Number(x.invoiceGrandTotal);
      }
    });

    setoutStockTotalSalesUSD(TotalSalesUSD);
    setoutStockTotalSalesLKR(TotalSalesLKR);
    setoutStockCurrentMonth(currentMonthINvoices);

    setoutStockPurchaseAmount(totalPurchase);
    setoutStockEstimatedAmount(totalEstimatedSales);
    setoutStockCurrentMonthSalesUSD(CurrentMonthSalesUSD);
    setoutStockCurrentMonthSalesLKR(CurrentMonthSalesLKR);
  }, [outStock, sales]);

  const memorizedTripData = useMemo(() => trips, [trips]);
  const inStockComponentRef = useRef();
  const outStockComponentRef = useRef();
  const inStockComponentPrint = useReactToPrint({
    pageStyle: `  
    @media print{
      @page {
          margin-top: 20px;
          margin-bottom: 20px;
           }
      body{
          
          -webkit-print-color-adjust: exact;
      }
      section{
      
      background-color: white;
  }
  h1{
      font-size: 20px;
      
  }
  p{
      font-size: 16px;
  }
  }
    `, // remove date/time from top

    // pageStyle:"@page { size: 8-1/4in 11-3/4in }",
    content: () => inStockComponentRef.current,
  });
  const outStockComponentPrint = useReactToPrint({
    pageStyle: `  
    @media print{
      @page {
          margin-top: 20px;
          margin-bottom: 20px;
           }
      body{
          
          -webkit-print-color-adjust: exact;
      }
      section{
      
      background-color: white;
  }
  h1{
      font-size: 20px;
      
  }
  p{
      font-size: 16px;
  }
  }
    `, // remove date/time from top

    // pageStyle:"@page { size: 8-1/4in 11-3/4in }",
    content: () => outStockComponentRef.current,
  });
  return (
    <div className="flex flex-col w-full">
      <div
       
        className="flex justify-evenly"
      >
        <div  style={{ background: "var(--main-bg)" , borderRadius:'var(--border-radius)'}} className="w-6/12 m-3  p-5 flex flex-col">
          <div ref={inStockComponentRef} className="flex flex-col p-2">
          <div className="font-extrabold text-3xl my-3 p-2 text-white bg-green-500">In Stock</div>

          <div className="border-b flex justify-between items-center py-4">
            <div className="font-extrabold">Gems Count</div>
            <div className="flex flex-col items-end font-extrabold bg-green-500 text-white px-2 py-1 rounded-full">{inStock.length}</div>
          </div>
          <div className="border-b flex justify-between items-center py-4">
            <div className="font-extrabold">Purchase Amount</div>
            <div className="flex flex-col items-end font-extrabold">
              {inStockPurchaseAmount.toLocaleString()} LKR
              <i className="font-light">{converter.toWords(Number(inStockPurchaseAmount))} LKR</i>
            </div>
          </div>

          <div className="border-b flex justify-between items-center py-4">
            <div className="font-extrabold">Estimated Sales Amount - LKR </div>
            <div className="flex flex-col items-end font-extrabold">
              {inStockEstimatedAmountLKR.toLocaleString()} LKR
              <i className="font-light">{converter.toWords(Number(inStockEstimatedAmountLKR))} LKR</i>
            </div>
          </div>
          <div className="border-b flex justify-between items-center py-4">
            <div className="font-extrabold">Estimated Sales Amount - USD </div>
            <div className="flex flex-col items-end font-extrabold">
              {inStockEstimatedAmountUSD.toLocaleString()} USD
              <i className="font-light">{converter.toWords(Number(inStockEstimatedAmountUSD))} USD</i>
            </div>
          </div>

         
          <div className="border-b flex justify-between items-center py-4">
            <div className="font-extrabold">This Month Purchase Amount - {inStockCurrentMonth.length}</div>
            <div className="flex flex-col items-end font-extrabold">
              {InStockCurrentMonthPurchase.toLocaleString()} LKR
              <i className="font-light">{converter.toWords(Number(InStockCurrentMonthPurchase))} LKR</i>
            </div>
          </div>
          <div className="border-b flex justify-between items-center py-4">
            <div className="font-extrabold">Total Available Precious</div>
            <div className="flex flex-col items-end font-extrabold bg-green-500 text-white px-2 py-1 rounded-full">
            {inStock.filter((x) => x.category === "Precious").length}
              {/* <i className="font-light">{converter.toWords(Number(outStockCurrentMonthSalesUSD))}</i> */}
            </div>
          </div>
          <div className="border-b flex justify-between items-center py-4">
            <div className="font-extrabold">Total Available Semi Precious</div>
            <div className="flex flex-col items-end font-extrabold bg-green-500 text-white px-2 py-1 rounded-full">
            {inStock.filter((x) => x.category !== "Precious").length}
              {/* <i className="font-light">{converter.toWords(Number(outStockCurrentMonthSalesUSD))}</i> */}
            </div>
          </div>
          </div>
        
 
          <div className="mt-5 bg-slate-900 p-3 text-white font-extrabold text-2xl text-center">
            {" "}
            Show All
          </div>
          <div className="mt-2 p-3 text-white font-extrabold text-2xl text-right ">
          <i onClick={()=>inStockComponentPrint()} className="cursor-pointer hover:bg-blue-800 bx bx-printer p-4 bg-blue-500 text-white font-extrabold"></i>
          </div>
        </div>

        <div
          style={{ background: "var(--main-bg)", borderRadius:'var(--border-radius)'}}
          className="w-6/12 m-3  p-5 flex flex-col"
        >
          <div ref={outStockComponentRef} className="flex flex-col">
          <div className="font-extrabold text-3xl my-3 p-2 text-white bg-red-500">Out Stock</div>
          <div className="border-b flex justify-between items-center py-4">
            <div className="font-extrabold">Gems Count</div>
            <div className="flex flex-col items-end font-extrabold">{outStock.length}</div>
          </div>
          <div className="border-b flex justify-between items-center py-4">
            <div className="font-extrabold">Purchase Amount</div>
            <div className="flex flex-col items-end font-extrabold">
              {outStockPurchaseAmount.toLocaleString()} LKR
              <i className="font-light">{converter.toWords(Number(outStockPurchaseAmount))} LKR</i>
            </div>
          </div>

          <div className="border-b flex justify-between items-center py-4">
            <div className="font-extrabold">Sales Amount - LKR SALES</div>
            <div className="flex flex-col items-end font-extrabold">
              {outStockTotalSalesLKR.toLocaleString()} LKR
              <i className="font-light">{converter.toWords(Number(outStockTotalSalesLKR))} LKR</i>
            </div>
          </div>

          <div className="border-b flex justify-between items-center py-4">
            <div className="font-extrabold">Sales Amount - USD SALES</div>
            <div className="flex flex-col items-end font-extrabold">
              {outStockTotalSalesUSD.toLocaleString()} USD
              <i className="font-light">{converter.toWords(Number(outStockTotalSalesUSD))} USD</i>
            </div>
          </div>
          <div className="border-b flex justify-between items-center py-4">
            <div className="font-extrabold">This Month Sales Amount - {outStockCurrentMonth.filter(x=>x.invoiceCurrency === "LKR").length} LKR SALES</div>
            <div className="flex flex-col items-end font-extrabold">
              {outStockCurrentMonthSalesLKR.toLocaleString()} LKR
              <i className="font-light">{converter.toWords(Number(outStockCurrentMonthSalesLKR))} LKR</i>
            </div>
          </div>
          <div className="border-b flex justify-between items-center py-4">
            <div className="font-extrabold">This Month Sales Amount - {outStockCurrentMonth.filter(x=>x.invoiceCurrency === "USD").length} USD SALES</div>
            <div className="flex flex-col items-end font-extrabold">
              {outStockCurrentMonthSalesUSD.toLocaleString()} USD
              <i className="font-light">{converter.toWords(Number(outStockCurrentMonthSalesUSD))} USD</i>
            </div>
          </div>
          <div className="border-b flex justify-between items-center py-4">
            <div className="font-extrabold">Total Sold Precious</div>
            <div className="flex flex-col items-end font-extrabold bg-red-500 text-white px-2 py-1 rounded-full">
            {outStock.filter((x) => x.category === "Precious").length}
              {/* <i className="font-light">{converter.toWords(Number(outStockCurrentMonthSalesUSD))}</i> */}
            </div>
          </div>
          <div className="border-b flex justify-between items-center py-4">
            <div className="font-extrabold">Total Sold Semi Precious</div>
            <div className="flex flex-col items-end font-extrabold bg-red-500 text-white px-2 py-1 rounded-full">
            {outStock.filter((x) => x.category !== "Precious").length}
              {/* <i className="font-light">{converter.toWords(Number(outStockCurrentMonthSalesUSD))}</i> */}
            </div>
          </div>
          </div>
        
 
          <div className="mt-5 bg-slate-900 p-3 text-white font-extrabold text-2xl text-center">
            {" "}
            Show All
          </div>
          <div className="mt-2 p-3 text-white font-extrabold text-2xl text-right ">
          <i onClick={()=>outStockComponentPrint()} className="cursor-pointer hover:bg-blue-800 bx bx-printer p-4 bg-blue-500 text-white font-extrabold"></i>
          </div>
        </div>
      </div>

      <Modal
        modal_title={"Create new trip"}
        canShow={showModal}
        updateModalState={toggleModal}
      >
        <TripEntry />
      </Modal>
      <Modal
        modal_title={"Edit Trip Information"}
        canShow={showEditModal}
        updateModalState={toggleEditModal}
      >
        <TripEntry
          data={selectedData}
          editMod={true}
          cancel={toggleEditModal}
        />
      </Modal>
    </div>
  );
};

export default Trips;
